import { useMutation } from "@tanstack/react-query";
import { updatePreferences } from "@/api/preferences";
import { usePreferencesManager } from "@/tanstackQuery/queries";

export const useDismissOnboardingSetup = () => {
  const prefsManager = usePreferencesManager();

  return useMutation({
    mutationFn: () => updatePreferences({ dismissOnboardingSetup: true }),

    onMutate: () => {
      const previous = prefsManager.get();
      prefsManager.patch({
        onboardingSetupDismissedAt: new Date().toISOString(),
      });
      return { previous };
    },

    onSuccess: (data) => {
      prefsManager.replace(data);
    },

    onError: (_error, _payload, context) => {
      if (context?.previous) {
        prefsManager.replace(context.previous);
      }
    },
  });
};
